import { ReactNode } from 'react';

type languageOptionsType = {
	[key: string]: {
		text: string;
		textFull: string;
		icon: ReactNode;
	}	
};

export const languageOptions: languageOptionsType = {
	"en": {
		text: "Eng",
		textFull: "English",
		icon: ""
	},
	"ka": {
		text: "Geo",
		textFull: "Georgian",
		icon: ""
	},	
	"ru": {
		text: "Rus",
		textFull: "Russian",
		icon: ""
	},
	"uk": {
		text: "Ukr",
		textFull: "Ukrainian",
		icon: ""
	},
};

export const supportedLanguages = Object.keys(languageOptions);